var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0387 13.448L16.5387 2.94804C15.8434 2.25281 14.881 1.83203 13.833 1.83203H5.66634C3.55458 1.83203 1.83301 3.5536 1.83301 5.66536V13.832C1.83301 14.8855 2.25777 15.8464 2.96068 16.5494L13.4607 27.0494C14.1559 27.7446 15.1183 28.1654 16.1663 28.1654C17.2123 28.1654 18.179 27.7458 18.8784 27.0313L27.0323 18.8774C27.7468 18.178 28.1663 17.2113 28.1663 16.1654C28.1663 15.1065 27.7259 14.1353 27.0387 13.448ZM7.41634 7.66536C7.27643 7.66536 7.16634 7.55527 7.16634 7.41536C7.16634 7.27546 7.27643 7.16536 7.41634 7.16536C7.55625 7.16536 7.66634 7.27546 7.66634 7.41536C7.66634 7.55527 7.55625 7.66536 7.41634 7.66536Z",
    stroke: "#6B62D1",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.35059,
    cy: 7.35059,
    r: 1.35059,
    fill: "#6B62D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag_icon.3f3d782c.svg";
export { ForwardRef as ReactComponent };